import { FC } from 'react';

import { Box } from '@bonusly/design-system';

/**
 * Subtle vignette and grain overlay for the fall theme
 * Creates a spooky, atmospheric effect without being intrusive
 */
export const BackgroundTint: FC = () => {
	return (
		<>
			{/* Vignette effect */}
			<Box
				position="fixed"
				top={0}
				left={0}
				width="100vw"
				height="100vh"
				pointerEvents="none"
				zIndex={1}
				background="radial-gradient(ellipse at center, transparent 0%, transparent 30%, rgba(0, 0, 0, 0.6) 100%)"
			/>

			{/* Film grain overlay */}
			<Box
				position="fixed"
				top={0}
				left={0}
				width="100vw"
				height="100vh"
				pointerEvents="none"
				zIndex={1}
				opacity={0.15}
				sx={{
					backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
					animation: 'grain 0.5s steps(4) infinite',
					'@keyframes grain': {
						'0%, 100%': { transform: 'translate(0, 0)' },
						'10%': { transform: 'translate(-5%, -5%)' },
						'20%': { transform: 'translate(-10%, 5%)' },
						'30%': { transform: 'translate(5%, -10%)' },
						'40%': { transform: 'translate(-5%, 10%)' },
						'50%': { transform: 'translate(-10%, 0%)' },
						'60%': { transform: 'translate(10%, 0%)' },
						'70%': { transform: 'translate(0%, 10%)' },
						'80%': { transform: 'translate(5%, 5%)' },
						'90%': { transform: 'translate(-5%, 0%)' },
					},
				}}
			/>
		</>
	);
};
